(function () {
  'use strict';

  angular.module('settings.embed', []);
})();
